/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Link from '@react/react-spectrum/Link';
import Icons from '../../utils/iconMapping';
import TranslationUtil from '../../utils/translation';
import './appInformation.scss';
import { InformationDialogAnalytics } from '../../analytics';

const ACTION_HANDLER_TYPES = {
    VIEW_MORE_CLICK: 'view-more-click',
};

const Languages = (props) => {
    const languageComponentList = [];
    const { data: { tabData, data: { app } } } = props;
    const { LinkOut } = Icons;
    tabData.languageList.forEach((lang) => {
        languageComponentList.push(<div key={lang} className="language">{lang}</div>);
    });
    return (
        <div className="tab-content">
            <h1 className="tab-title">{TranslationUtil.getMessage(`ccx.app-info-dialog.${tabData.tabId}`)}</h1>
            <div className="languages-tab-content">
                {languageComponentList}
            </div>
            {tabData.subText && (
                <div className="language-sub-text">
                    <span>{tabData.subText.text}</span>
                    <Link
                        href="#"
                        className="sub-text-view-more"
                        onClick={(e) => {
                            e.preventDefault();
                            // TODO: send guid for ext link clicks
                            InformationDialogAnalytics.languageViewMoreClick(
                                app,
                                tabData.subText.viewMore
                            );
                            props.actionHandler(
                                e,
                                ACTION_HANDLER_TYPES.VIEW_MORE_CLICK,
                                tabData.subText.viewMore,
                            );
                        }}>
                        <span>{tabData.subText.viewMore.text}</span>
                        <LinkOut size="XS" />
                    </Link>
                </div>
            )}
        </div>
    );
};
export default Languages;
